/**
 * Colores de los valores de atributos (Rojo, Azul marino, Negro...).
 * Se usa en Atributos de productos, el formulario de producto, el POS y Nuevo Comprobante.
 */

// nombre del color en minúsculas y sin tildes => color hexadecimal
const COLOR_NAMES = {
    'azul marino': '#1A237E',
    'verde oliva': '#808000',
    'rojo': '#E53935',
    'azul': '#1E88E5',
    'negro': '#212121',
    'blanco': '#FFFFFF',
    'verde': '#43A047',
    'amarillo': '#FDD835',
    'naranja': '#FB8C00',
    'anaranjado': '#FB8C00',
    'morado': '#8E24AA',
    'purpura': '#8E24AA',
    'lila': '#B39DDB',
    'rosado': '#F48FB1',
    'rosa': '#F48FB1',
    'fucsia': '#D81B60',
    'gris': '#9E9E9E',
    'marron': '#6D4C41',
    'cafe': '#6D4C41',
    'celeste': '#4FC3F7',
    'turquesa': '#26C6DA',
    'beige': '#D7CCC8',
    'crema': '#FFF8E1',
    'dorado': '#D4AF37',
    'plateado': '#C0C0C0',
    'vino': '#7B1F3A',
    'guinda': '#7B1F3A',
    'mostaza': '#E1AD01',
    'coral': '#FF7F50',
}

// colores de acceso rápido en el selector de tonalidad
export const PREDEFINED_COLORS = Object.keys(COLOR_NAMES)
    .map(name => COLOR_NAMES[name])
    .filter((color, index, colors) => colors.indexOf(color) === index)

function normalize(text) {
    return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim()
}

/**
 * Color sugerido para un valor según su nombre, o null si no es un color conocido.
 * "Rojo" => #E53935, "Azul marino" => #1A237E, "Rojo oscuro" => #E53935, "XL" => null
 */
export function suggestColor(value) {
    const name = normalize(value)
    const key = Object.keys(COLOR_NAMES)
        .sort((a, b) => b.length - a.length)
        .find(color => name === color || name.indexOf(color + ' ') === 0)

    return key ? COLOR_NAMES[key] : null
}

/**
 * Estilo del círculo de color que acompaña a un valor.
 */
export function colorDotStyle(color) {
    return {
        display: 'inline-block',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid #dcdfe6',
        marginRight: '6px',
        verticalAlign: 'middle',
    }
}



// WEBPACK FOOTER //
// ./resources/js/helpers/attribute_colors.js